import React, { useContext } from "react";
import { RootStoreContext } from "../store/rootStore";
import { observer } from "mobx-react-lite";


const CoCurricularFilters:React.FC = observer(() => {

  const rootStore = useContext(RootStoreContext);

  const {
    ccSetShowFilter,
    ccShowFilter, ccDays, ccTerms, ccSubjectAreas, ccForms,
    ccSetChosenDay, ccChosenDays,
    ccSetChosenTerm, ccChosenTerms,
    ccSetChosenSubjectArea, ccChosenSubjectAreas,
    ccSetChosenForm, ccChosenForms,
    filteredCards
  } = rootStore.coCurricularStore;

  if(ccShowFilter === null) return;

  return (
    <div className='filters__holder no-overlay'>
      <div className='filters shown'>
        <div className='filters__inner'>

          <p className='filters__title'>Filter by day(s)...</p>
          <div className='filters__groups buttons filters__groups_subjects'>
            {ccDays && ccDays.map(day => 
              <button key={day} onClick={() => ccSetChosenDay(day)}
                className={ccChosenDays.find(chosenDay => chosenDay === day) ? 'chosen' : ''}
              >{day}</button>
            )}
          </div>

          <p className='filters__title'>Filter by times(s)...</p>
          <div className='filters__groups buttons filters__groups_subjects'>
            {ccSubjectAreas && ccSubjectAreas.map(subjectArea => 
              <button key={subjectArea} onClick={() => ccSetChosenSubjectArea(subjectArea)}
                className={ccChosenSubjectAreas.find(chosenSubjectArea => chosenSubjectArea === subjectArea) ? 'chosen' : ''}
              >{subjectArea}</button>
            )}
          </div>

          <p className='filters__title filters__title-years'>Filter by year group(s)...</p>
          <div className='filters__groups filters__groups_years'>
            {ccForms && ccForms.map(form => 
              <button key={form} onClick={() => ccSetChosenForm(form)}
                className={ccChosenForms.find(chosenForm => chosenForm === form) ? 'year chosen' : 'year'}
              >{form}</button>
            )}
          </div>

          <p className='filters__title filters__title-terms'>Filter by term(s)...</p>
          <div className='filters__groups filters__groups_terms'>
            {ccTerms && ccTerms.map(term => 
              <button key={term} onClick={() => ccSetChosenTerm(term)}
                className={ccChosenTerms.find(chosenTerm => chosenTerm === term) ? 'chosen' : ''}
              >{term}</button>
            )}
          </div>


          <button className='filters__hide-filters' onClick={() => ccSetShowFilter()}>Show results</button>

        </div>
      </div>
    </div>
  );

});

export default CoCurricularFilters;